import * as core from '../../../../../../../core'
import * as spaceSurveyStatus from '../space-survey-status'

export const RESOURCE = {
  payload: {
    description: 'Signed Off',
    enumId: core.dms.models.Enum.Id.from({
      partialId: spaceSurveyStatus.RESOURCE.payload.partialId,
    }),
    id: 'SIGNED_OFF',
    name: 'Signed Off',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
